import { render, staticRenderFns } from "./AppType.vue?vue&type=template&id=61ce59e2&scoped=true"
import script from "./AppType.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppType.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppType.vue?vue&type=style&index=0&id=61ce59e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ce59e2",
  null
  
)

export default component.exports